var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"land-trust"},[_c('div',{staticClass:"quick-banner"},[_c('div',{staticClass:"map-btn-container"},[_c('el-button',{staticClass:"map-btn",attrs:{"type":"primary"},on:{"click":function($event){return _vm.toShop()}}},[_vm._v("农资服务")])],1),_c('AgriMapViewer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }